






























import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { searchToWhereUrl } from '@core/utils/jump'
import { Icon } from 'vant'

@Component({
  components: {
    [Icon.name]: Icon,
  },
})
export default class BusinessItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any
  @Prop({ default: 1 }) readonly type!: number //1表示普通 搜索列表样式  2表示卡片 城市站样式

  get goDetail() {
    return searchToWhereUrl({ spuType: 402, spuId: this.value.spuId, businessId: this.value.businessId , module: 4 }) //spuType: 402 页面跳商品详情
    // return searchToWhereUrl({ spuType: toNumber(this.value.templateType2Id), spuId: this.value.spuId, businessId: this.value.businessId })
  }

  goBusinessDetail() {
    const { isSpot, businessType, businessId } = this.value
    const url = searchToWhereUrl({ toShop: true, businessType, businessId, isSpot })
    location.href = url
  }

  //标签 1营销标签 promotion1 接口约定只有一个  2普通标签 promotion2 最多4个
  get promotionTag() {
    return (type: number) => {
      const { promotion1 = [], promotion2 = [] } = JSON.parse(this.value.promotions)
      if (type === 1) {
        const [p = ''] = promotion1
        return p
      } else {
        //spuSpotEndTime> 0 可订今日票
        if (this.value.spuSpotEndTime) return [...promotion2, '可订今日票']
        return promotion2
      }
      return ''
    }
  }
}
